import { VOICE_ORDER_CRUMBS } from "../../constants/crumbs";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import VoiceOrderInstructions from "./VoiceOrderInstructions/VoiceOrderInstructions";
import VoiceOrderForm from "./VoiceOrderForm/VoiceOrderForm";
import classes from "./VoiceOrder.module.css";

const VoiceOrder = () => {
  return (
    <div className={classes["voice-order"]}>
      <PortalBreadcrumb paths={VOICE_ORDER_CRUMBS} />
      <div className={classes["voice-order__content-wrapper"]}>
        <VoiceOrderInstructions />
        <VoiceOrderForm />
      </div>
    </div>
  );
};

export default VoiceOrder;
